export const TIPOS_EMBARCACION = [
  { value: 'balsa', label: 'Balsa' },
  { value: 'barco-de-pesca', label: 'Barco de pesca' },
  { value: 'bote-a-motor', label: 'Bote a motor' },
  { value: 'bote-a-remo', label: 'Bote a remo' },
  { value: 'canoa', label: 'Canoa' },
  { value: 'jetski', label: 'Jet ski' },
  { value: 'kayak', label: 'Kayak' },
  { value: 'lancha', label: 'Lancha' },
  { value: 'lancha-cubierta', label: 'Lancha cubierta' },
  { value: 'lancha-neumatica-gomon', label: 'Lancha neumática/gomón' },
  { value: 'moto-de-agua', label: 'Moto de agua' },
  { value: 'semirigido', label: 'Semirrígido' },
  { value: 'ski-acuatico', label: 'Ski acuático' },
  { value: 'tabla', label: 'Tabla' },
  { value: 'tabla-a-vela', label: 'Tabla a vela' },
  { value: 'velero', label: 'Velero' },
];
